// Original, deterministic 24×24 stroke icons. Shared by web and PDF renderers.
// Semantic navigation aids only: never scores, probabilities or good/bad omens.
export const REPORT_ICONS = {
  direction: { label: '方向', path: 'M12 3L20 12L12 21L4 12Z M12 7V17 M8 12H16' },
  career: { label: '事业', path: 'M8 7V4H16V7 M3 8H21V20H3Z M3 12L12 15L21 12 M10 14V17H14V14' },
  resource: { label: '资源', path: 'M3 8L12 3L21 8L12 13Z M3 12L12 17L21 12 M3 16L12 21L21 16' },
  horizon: { label: '外部机会', path: 'M2 18H22 M5 15A7 7 0 0 1 19 15 M12 2V5 M3 6L5 8 M21 6L19 8 M9 21H15' },
  relationship: { label: '关系', path: 'M9 9C5 4 1 10 5 14L12 20L19 14C23 10 19 4 15 9L12 12Z' },
  home: { label: '生活基础', path: 'M3 11L12 3L21 11 M5 10V21H19V10 M10 21V14H14V21' },
  act: { label: '行动', path: 'M4 17L15 6 M7 6H15V14 M4 21H20' },
  prepare: { label: '准备', path: 'M4 5H20V21H4Z M8 3V7 M16 3V7 M4 10H20 M8 15H10 M14 15H16' },
  review: { label: '复盘', path: 'M19 8A8 8 0 1 0 20 16 M19 3V8H14 M12 7V12L8 15' },
  connect: { label: '协作', path: 'M9 15L15 9 M8 17L6 19A4 4 0 0 1 1 13L6 8A4 4 0 0 1 12 9 M16 7L18 5A4 4 0 0 1 23 11L18 16A4 4 0 0 1 12 15' },
  recover: { label: '恢复', path: 'M19 3C19 13 16 20 7 19C1 14 5 4 19 3Z M5 22L14 9' },
  evidence: { label: '依据', path: 'M5 3H15L20 8V21H5Z M15 3V8H20 M8 12H16 M8 16H14' },
} as const;
export type ReportIconName = keyof typeof REPORT_ICONS;
export function reportModeIcon(mode: string): ReportIconName {
  return ({ ACT: 'act', BUILD: 'act', PREPARE: 'prepare', CONNECT: 'connect', REVIEW: 'review', RECOVER: 'recover' } as const)[mode as 'ACT'] || 'direction';
}
export function reportRoleIcon(role: string): ReportIconName {
  return ({ CORE: 'direction', WORK: 'career', RESOURCE: 'resource', HORIZON: 'horizon' } as const)[role as 'CORE'] || 'direction';
}
